import { render } from "./agent-card.vue?vue&type=template&id=005f36b2"
import script from "./agent-card.vue?vue&type=script&lang=js"
export * from "./agent-card.vue?vue&type=script&lang=js"

import "./agent-card.vue?vue&type=style&index=0&id=005f36b2&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-team/layout1/agent-card.vue'],['render',render],['__file',"agent-card.vue"]])

export default __exports__